module.exports = __webpack_public_path__ + "img/14.43f41f42.jpg";